import { useEffect } from "react"
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import queryString from "query-string";
import { getUseronboardingInfo, logOutUser } from "../../../../actions/loginActions";
import { UPDATE_FIRST_RUN } from "../../../../reducers/keys"; 
import { getWidgetWallData } from "../../../../actions/wallDataAction";
import { getWallIdNew } from "../../../../utils";
import LoadingScreen from "../../../CommonComponents/LoadingScreen";

let request = true;
function ProductLogin() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();
    const parsed = queryString.parse(window.location.search);
    const redirectUrl = (parsed && Object.keys(parsed).length > 0 && parsed.redirect) ? parsed.redirect : null;
    const isAdmin = (parsed && Object.keys(parsed).length > 0 && parsed.admin) ? parsed.admin : null;
    const wallUrl = redirectUrl.includes('wall/index')
    const wallId = getWallIdNew(redirectUrl)


    const redirectURL=(redirectURL,access)=>{  
        const ownerId = localStorage.getItem('ownerId')
        request = true;

        if(!redirectURL) localStorage.removeItem('authToken');
        dispatch({ type: UPDATE_FIRST_RUN, payload: true });

        setTimeout(() => {
            if(wallUrl) dispatch(getWidgetWallData(ownerId,wallId))
            navigate(access==2 ? redirectUrl.includes('otherinfo') ? redirectUrl : '/onboarding' : redirectUrl, { replace: true })
        }, 200);
    }

    useEffect(() => {
        if(wallId) localStorage.setItem('wallId',wallId);
        if(isAdmin) localStorage.setItem('Isadmin',1)
        let token = localStorage.getItem('access_token');
        if (request) {
            request = false;
            //if token or user data is not present then it data will be refreshed
           //const callApi = !token ? true : token != atob(params.token) ? true : false;
            const wallId = localStorage.getItem('wallId')
            const ownerId = localStorage.getItem('ownerId')
            localStorage.setItem('manage_switcher',1)
            localStorage.setItem('loginOwnerId',params.token)
 
            try {
                if (params.token) {
                    token = params.token;
                    localStorage.setItem('authToken', token);
                    const beforeVerify = redirectUrl.includes('otherinfo') ? true : false
                    dispatch(getUseronboardingInfo(false, beforeVerify, redirectURL));
                } else {
                    if (redirectUrl) {
                       if(wallUrl) dispatch(getWidgetWallData(ownerId,wallId))
                         setTimeout(() => {
                           navigate(redirectUrl, { replace: true });
                         }, 200)  
                    }
                    else {  
                        const url = `/walls/home`;
                        navigate(url, { replace: true });
                    }
                    request = true;
                }
            } catch (error) {
                logOutUser();
                console.log("error while product login", error);
            }
        }
    }, [])


    return <LoadingScreen switcher={1} />
}



export default ProductLogin;